/**
 * @author: junjunzuo(junjunzuo@tencent.com)
 * @description: detail
 * @Date: 2020-06-15 16:43:40
 */

import * as types from '@types';
import axios from 'axios';

export default {
  namespaced: true,
  state: () => ({
    head: '',
    itemData: {},
    playInfoIndex: 0,
    finishEpisode: '',
  }),
  mutations: {
    [types.UPDATE_HEAD](state, head) {
      state.head = head;
    },
    [types.UPDATE_ITEM](state, item) {
      state.itemData = item;
    },
    [types.UPDATE_PLAYINFOINDEX](state, index) {
      state.playInfoIndex = index;
    },
    [types.UPDATE_FINISH_EPISODE](state, finishEpisode) {
      state.finishEpisode = finishEpisode;
    },
  },
  actions: {
    /**
     * 电影/电视剧/综艺/动漫 详情页获取检索结果
     */
    async prefetchData({ commit }, { context, route }) {
      const key = route.params.key || '';
      const dockey = route.params.dockey || '';
      const title = route.params.title || '';
      const name = route.name || '';
      const router = {
        key,
        dockey,
        title,
        type: name,
      };
      const $params = context ? context.$params : {};
      const params = Object.assign({}, route.query, { routeName: route.name }, $params, router);
      let result = await axios({
        url: `${types.ORIGIN_CLIENT}/napi/video/detail`,
        params,
        timeout: 4500,
      }).catch(err => console.log(err));

      result = result && result.data;
      const { status, head = '', item } = result || {};
      if (status === 301) return result;
      if (status === 0 && item) {
        commit(types.UPDATE_HEAD, head);
        commit(types.UPDATE_ITEM, item);
        return result;
      }
      return {
        status: 302,
        redirectUrl: '/?prefetch_redirect=1',
      };
    },
    /**
     * 电影-simple页 获取数据
     */
    async prefetchMovieSimpleData({ commit }, { context, route }) {
      const dockey = route.params.dockey || '';
      const title = route.params.k || '';
      const name = route.name || '';
      const router = {
        dockey,
        title,
        name,
      };
      const params = Object.assign({}, route.query, { routeName: route.name }, context.config || {}, router);
      let result = await axios({
        url: `${types.ORIGIN_CLIENT}/napi/video/detail/movepy`,
        params,
        timeout: 4500,
      }).catch(err => console.log(err));

      result = result && result.data;
      const { status, head = '', item } = result || {};
      if (status === 301) return result;
      if (status === 0 && item) {
        commit(types.UPDATE_HEAD, head);
        commit(types.UPDATE_ITEM, item);
        return result;
      }
      commit(types.UPDATE_HEAD, '');
      commit(types.UPDATE_ITEM, {});

      return {
        status: 302,
        redirectUrl: '/?prefetch_redirect=1',
      };
    },
  },
};
